export enum ESortDirection {
	ASC = 'asc',
	DESC = 'desc'
}
